import type { CompanySearchResponse, CompanySearchScope } from "@paperclipai/shared";
import { api } from "./client";

export interface CompanySearchParams {
  q: string;
  scope?: CompanySearchScope;
  limit?: number;
  offset?: number;
}

export const searchApi = {
  search: (companyId: string, params: CompanySearchParams) =>
    api.post<CompanySearchResponse>(`/companies/${companyId}/search`, {
      q: params.q,
      scope: params.scope,
      limit: params.limit,
      offset: params.offset,
    }),
};
